import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransactionTypeReducer } from '../reducers';

export const selectTransactionTypeFeature = createFeatureSelector<TransactionTypeReducer.TransactionTypeState>(TransactionTypeReducer.featureName);

export const selectTransactionType = createSelector(selectTransactionTypeFeature, (state: TransactionTypeReducer.TransactionTypeState) => state.item);
